<template>
    <Form @submit="submit">
        <div :style="{'display':spcp?'none':''}">
            <Field
                    required
                    clearable
                    label="旧密码"
                    placeholder="请输入密码"
                    right-icon="closed-eye"
                    @click-right-icon="showPsw()"
                    v-model="user.oldPassword"
                    type="password"
            /><div></div>
        </div>
        <div :style="{'display':!spcp?'none':''}">
            <Field
                    required
                    clearable
                    label="旧密码"
                    placeholder="请输入密码"
                    right-icon="eye-o"
                    @click-right-icon="hidePsw()"
                    v-model="user.oldPassword"
            /><div></div>
        </div>
        <div :style="{'display':nspcp?'none':''}">
            <Field
                    required
                    clearable
                    label="新密码"
                    placeholder="请输入密码"
                    right-icon="closed-eye"
                    @click-right-icon="showNewpsw()"
                    v-model="user.newPassword"
                    type="password"
                    :rules="[
                    {  required: true, message: '请输入密码' },
                    {  pattern: /[0-9]/,message:'至少包含一个数字'},
                    {  pattern: /(?:.*?[!@#$%*()_+^&}{:;?.`])/,message:'至少包含一个特殊符号'},
                    {  pattern: /[a-z]/,message:'至少包含一个小写字母'}
                            ]"
            /><div></div>
        </div>
        <div :style="{'display':!nspcp?'none':''}">
            <Field
                    required
                    clearable
                    label="新密码"
                    placeholder="请输入密码"
                    right-icon="eye-o"
                    @click-right-icon="hideNewpsw()"
                    v-model="user.newPassword"
                    :rules="[
                    {  required: true, message: '请输入密码' },
                    {  pattern: /[0-9]/,message:'至少包含一个数字'},
                    {  pattern: /(?:.*?[!@#$%*()_+^&}{:;?.`])/,message:'至少包含一个特殊符号'},
                    {  pattern: /[a-z]/,message:'至少包含一个小写字母'}
                            ]"
            /><div></div>
        </div>
        <div :style="{'display':cspcp?'none':''}">
            <Field
                    required
                    clearable
                    label="确认密码"
                    placeholder="请输入密码"
                    right-icon="closed-eye"
                    @click-right-icon="showConpsw()"
                    v-model="user.confirmPassword"
                    type="password"
                    :rules="[
                { required: true, message: '请输入密码' },
                { validator  : validatorPassword, message: '两次密码不一致' },
                ]"
            />
        </div>
        <div :style="{'display':!cspcp?'none':''}">
            <Field
                    required
                    clearable
                    label="确认密码"
                    placeholder="请输入密码"
                    right-icon="eye-o"
                    @click-right-icon="hideConpsw()"
                    v-model="user.confirmPassword"
                    :rules="[
                { required: true, message: '请输入密码' },
                { validator  : validatorPassword, message: '两次密码不一致' },
                ]"
            />
        </div>
        <Button type="info" block style="width: 95% ; margin: 10px auto;" native-type="submit">确认修改</Button>
    </Form>
</template>

<script>
    import {Button, Field, Form, PasswordInput} from "vant";

    export default {
        components: {Form, Field, Button, PasswordInput},
        props: {},
        data() {
            return {
                user: {
                    oldPassword: null,
                    newPassword: null,
                    confirmPassword: null,
                },
                spcp: false,
                nspcp: false,
                cspcp: false
            }
        },
        computed: {},
        created() {
        },
        mounted() {
        },
        methods: {
            showPsw() {
                this.spcp = true;
            },
            hidePsw() {
                this.spcp = false;
            },
            showNewpsw() {
                this.nspcp = true;
            },
            hideNewpsw() {
                this.nspcp = false;
            },
            showConpsw() {
                this.cspcp = true;
            },
            hideConpsw() {
                this.cspcp = false;
            },
            validatorPassword(value) {
                const newPassword = this.user.newPassword;
                if (newPassword == value) {
                    return true;
                } else {
                    return false;
                }
            },
            submit() {
                this.$toast.loading("正在处理中...")
                this.$http.tokiot.sys.user.changePassword(this.user)
                    .then(res => {
                        this.$toast.clear();
                        if (res) {
                            this.$toast.success("修改成功")
                            this.$http.wechat.unbind({})
                                .then(ret => {
                                    if (ret) {
                                        setTimeout(() => {
                                            this.$router.push("/account/bind");
                                        }, 1000);
                                    }
                                })
                        } else {
                            this.$toast.fail(res.message)
                        }
                    })
            }
        },
        watch: {}
    }
</script>

<style scoped>

</style>